import Link from '@mui/material/Link';
import { t } from 'i18next';
import React from 'react';

import { ROUTES as routes } from '~router/routePaths';

const LinkToForgotPassword = () => {
  return (
    <Link
      href={routes.forgot}
      variant="body2"
      sx={{
        color: 'secondary.main',
      }}
    >
      {t('page_headings.forgot_password')}
    </Link>
  );
};
export default LinkToForgotPassword;
